import { field, formatUnits, readContract, writeContractAndWait } from "../viem";
import { approveToken, getTokenAllowance } from ".";
import MafiaRankStakeABI from "../../abis/MafiaRankStake.json";
import config from "../../config/config";

const address = config.rankStake;
const abi = MafiaRankStakeABI;

export const approveRankStakeContract = async (
  account: string,
  approveAmount: number
) => {
  const tokenAddress = config.mafiaAddress;
  const contractAddress = config.rankStake;

  const allowance = await getTokenAllowance(
    tokenAddress,
    account,
    contractAddress
  );

  if (Number(allowance) < approveAmount * 1.1) {
    await approveToken(
      tokenAddress,
      approveAmount * 1.1,
      contractAddress,
      account
    );
  }
};

export const stake = async (account: string) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "stake",
    account,
  });
  return data;
};

export const unstake = async (account: string) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "unstake",
    account,
  });
  return data;
};

export const adjustStake = async (account: string) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "adjustStake",
    account,
  });
  return data;
};

export const isUserRankActive = async (account: string) => {
  const data = await readContract({
    address,
    abi,
    functionName: "isUserRankActive",
    args: [account],
  });
  return data;
};

export const getMissingAmount = async (account: string) => {
  const data: any = await readContract({
    address,
    abi,
    functionName: "getMissingAmount",
    args: [account],
  });
  return Number(formatUnits(data, 18));
};

export const getReductionPercents = async (account: string) => {
  const data: any = await readContract({
    address,
    abi,
    functionName: "getReductionPercents",
    args: [account],
  });
  return {
    familyReductionPercent: Number(field(data, "familyReductionPercent", 1)) / 10,
    equipmentReductionPercent: Number(field(data, "equipmentReductionPercent", 2)) / 10,
    buildingReductionPercent: Number(field(data, "buildingReductionPercent", 3)) / 10,
  };
};

export const getUserStakingInfo = async (account: string) => {
  const data: any = await readContract({
    address,
    abi,
    functionName: "getUserStakingInfo",
    args: [account],
  });

  return {
    stakes: (field(data, "stakes", 0) || []).map((stake: any) => ({
      rankLevel: Number(field(stake, "rankLevel", 0)),
      amount: Number(formatUnits(field(stake, "amount", 1), 18)),
      reductionPercent: Number(field(stake, "reductionPercent", 2)),
      timestamp: Number(field(stake, "timestamp", 3)),
    })),
    currentStakeLevel: Number(field(data, "currentStakeLevel", 1)),
    totalAmount: Number(formatUnits(field(data, "totalAmount", 2), 18)),
    lastUnstakeTime: Number(field(data, "lastUnstakeTime", 3)),
  };
};

export const getUnstakeCooldown = async () => {
  const data: any = await readContract({
    address,
    abi,
    functionName: "unstakeCooldown",
  });
  return Number(data);
};
